import { render, staticRenderFns } from "./CockpitTextComponent.vue?vue&type=template&id=5c3a15db&scoped=true"
import script from "./CockpitTextComponent.vue?vue&type=script&lang=js"
export * from "./CockpitTextComponent.vue?vue&type=script&lang=js"
import style0 from "./CockpitTextComponent.vue?vue&type=style&index=0&id=5c3a15db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a15db",
  null
  
)

export default component.exports